import moment from 'moment';

export const formatDate = (value, format)=>{
	if(!value){
		return ''
	}
	return moment(value).format(format);
}

// export const formatSource =(date)=> {
// 	console.log(date," filter")
// 	if (date == null || date == "") {
// 		return "";
// 	}
// 	switch(date){
// 		case "0" : return "苹果端";
// 		case "1" : return "安卓端";
// 		case "2" : return "微信小程序端";
// 		case "3" : return "WEB端";
// 		case "4" : return "第三方网站";
// 		default:return date;
// 	}
// }